var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("\n    "+_vm._s(_vm.workflowId)+"\n  ")]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{
        name: 'workflow/summary',
        params: {
          runId: _vm.runId,
          workflowId: _vm.workflowId,
        },
      }}},[_vm._v("\n      "+_vm._s(_vm.runId)+"\n    ")])],1),_vm._v(" "),_c('td',[_vm._v("\n    "+_vm._s(_vm.workflowName)+"\n  ")]),_vm._v(" "),_c('td',[_vm._v("\n    "+_vm._s(_vm.closeStatus)+"\n  ")]),_vm._v(" "),_c('td',[_vm._v("\n    "+_vm._s(_vm.startTime)+"\n  ")]),_vm._v(" "),_c('td',[_vm._v("\n    "+_vm._s(_vm.closeTime)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b8da3af","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/namespace/workflow-archival/components/archival-table-row.vue
// module id = 1564
// module chunks = 0